import { createIntl, createIntlCache, type IntlShape } from 'react-intl';

import en from '../locales/en.json';
import ru from '../locales/ru.json';

export const supportedLocales = ['en', 'ru'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

const messages = { en, ru } satisfies Record<
  SupportedLocale,
  Record<keyof typeof en, string>
>;
const cache = createIntlCache();

export function resolveLocale(locale: string | undefined): SupportedLocale {
  const language = locale?.toLowerCase().split(/[._@-]/)[0];
  return language === 'ru' ? 'ru' : 'en';
}

export function createAppIntl(locale: string | undefined): IntlShape {
  const resolved = resolveLocale(locale);
  return createIntl({ locale: resolved, messages: messages[resolved] }, cache);
}
